import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '../../theme/colors';
import spacing, { isMobileScreen } from '../../theme/spacing';
import { GOOGLE_PLAY_STORE_URL, IOS_APP_STORE_URL } from '../../constants/urls';

// Import badges
import AppleBadgeEn from '../../assets/mobileStores/apple-download-badge-en.svg';
import AppleBadgeLt from '../../assets/mobileStores/apple-download-badge-lt.svg';
import GoogleBadgeEn from '../../assets/mobileStores/google-download-badge-en.png';
import GoogleBadgeLt from '../../assets/mobileStores/google-download-badge-lt.png';

const DistributionFooter = () => {
  const { i18n } = useTranslation();

  // Determine which badge to show based on current language
  const currentLanguage = i18n.language;
  const isLithuanian = currentLanguage === 'lt';

  const appleBadge = isLithuanian ? AppleBadgeLt : AppleBadgeEn;
  const googleBadge = isLithuanian ? GoogleBadgeLt : GoogleBadgeEn;

  const BADGE_HEIGHT = isMobileScreen ? 35 : 40;

  // Standard sizes for app store badges
  const appleBadgeStyle: React.CSSProperties = {
    height: BADGE_HEIGHT,
    width: 'auto', // Maintain aspect ratio
    cursor: 'pointer',
    transition: 'opacity 0.2s ease, transform 0.2s ease',
    display: 'block',
  };

  const googleBadgeStyle: React.CSSProperties = {
    height: BADGE_HEIGHT,
    width: 'auto', // Maintain aspect ratio
    cursor: 'pointer',
    transition: 'opacity 0.2s ease, transform 0.2s ease',
    display: 'block',
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: spacing.medium,
        padding: `${spacing.medium} ${spacing.medium}`,
        backgroundColor: colors.backgroundMediumLight,
      }}
    >
      {/* App Store Badge */}
      <a
        href={IOS_APP_STORE_URL}
        style={{
          display: 'inline-block',
          textDecoration: 'none',
        }}
        onMouseEnter={(e) => {
          const img = e.currentTarget.querySelector('img');
          if (img) {
            img.style.opacity = '0.8';
            img.style.transform = 'scale(1.05)';
          }
        }}
        onMouseLeave={(e) => {
          const img = e.currentTarget.querySelector('img');
          if (img) {
            img.style.opacity = '1';
            img.style.transform = 'scale(1)';
          }
        }}
      >
        <img
          src={appleBadge}
          alt={
            isLithuanian
              ? 'Parsisiųsti iš App Store'
              : 'Download on the App Store'
          }
          style={appleBadgeStyle}
        />
      </a>

      {/* Google Play Badge */}
      <a
        href={GOOGLE_PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          textDecoration: 'none',
        }}
        onMouseEnter={(e) => {
          const img = e.currentTarget.querySelector('img');
          if (img) {
            img.style.transform = 'scale(1.05)';
          }
        }}
        onMouseLeave={(e) => {
          const img = e.currentTarget.querySelector('img');
          if (img) {
            img.style.transform = 'scale(1)';
          }
        }}
      >
        <img
          src={googleBadge}
          alt={
            isLithuanian
              ? 'Parsisiųsti iš Google Play'
              : 'Get it on Google Play'
          }
          style={googleBadgeStyle}
        />
      </a>
    </div>
  );
};

export default DistributionFooter;
